import React, {useContext, Component} from 'react';
import firebase from 'firebase/compat/app'
import "firebase/compat/auth";
import 'firebase/compat/database';
import '../../agrari-styles/perfil.css';
import { Grid, Container } from 'semantic-ui-react'
import { AuthContext } from "../../Auth.js"
import {getCompanyCollection} from '../../firebase'

function Data() {
    const { currentUser } = useContext(AuthContext)
	console.log(currentUser)
    return (
    <div>
        <PaginaEmpleados currentUser={currentUser}/>
    </div>
    )
}

class PaginaEmpleados extends Component{
	constructor(props){
		super(props);
		this.currentUser=this.props.currentUser;
		this.app= firebase;
		this.database = null;
		this.storage = this.app.storage().ref();
		this.state = {
			employeeInfo: null,
			loading: true,
            employeeID: this.currentUser.user_id,
            employeeName: this.currentUser.name,
		}
		this.unsubscribe = null;
	}

	async componentDidMount(){
		this.database = await getCompanyCollection('Empleados')
		this.getData()
	}

	getData = () => { 
		this.unsubscribe = this.database.where('uid', '==', this.state.employeeID).onSnapshot( async snap =>{
			const empleados = [] 
			for(let i=0; i<snap.docs.length; i++){
				const doc=snap.docs[i]
				const data = doc.data()
				let url = ''
				if (data.foto) {
					try {
						url = await this.storage.child(`images/profile-pics/${data.foto}.jpg`).getDownloadURL()
					} catch(error) {
						console.log('No fue posible cargar la foto de perfil', error)
					}
				}
				empleados.push({
					id: doc.id,
					nombre: data.Nombre,
					correo: data.Correo,
					rol: data.rol,
					foto: data.foto,
					imss: data.IMSS,
					nacimiento: data.Nacimiento,
					telefono: data.telefono,
					url: url,
				}) 
				
				if (!this.state.employeeName){
					firebase.auth().currentUser.updateProfile({
						displayName: data.Nombre
					}).then(() => {
						console.log("Nombre cambiado")
					}).catch((error) => {
						console.log(error)
					});
				}
			}
			const employeeInfo = empleados[0] || {
				id: this.state.employeeID,
				nombre: this.currentUser.name || this.currentUser.email || 'Administrador',
				correo: this.currentUser.email || '',
				rol: this.currentUser.rol || '',
				foto: this.state.employeeID,
				nacimiento: null,
				telefono: '',
			}
			this.setState({
				employeeInfo,
				loading: false,
			})
		}, error => {
			console.error('No fue posible cargar el perfil', error)
			this.setState({loading: false})
		})
	
	}

	componentWillUnmount(){
		if (this.unsubscribe) this.unsubscribe()
	}

	formatDate = (date) => {
		if (!date) return ''
		if (typeof date.toDate === 'function') return date.toDate().toLocaleDateString()
		const parsedDate = new Date(date)
		return Number.isNaN(parsedDate.getTime()) ? '' : parsedDate.toLocaleDateString()
	}

	render(){
		if (this.state.loading) return <p>Cargando perfil...</p>
		if (!this.state.employeeInfo) return <p>No fue posible cargar los datos del perfil.</p>

		const employeeInfo = this.state.employeeInfo
		return (
			<>
			{//<img src={this.state.employeeInfo.url} alt={this.id} width="100" height="120"></img>
			}
			<h2>{employeeInfo.nombre}</h2>
			<Container text>
				<Grid columns={2} divided >
					<Grid.Row>
						<Grid.Column>
							<Container textAlign='right'><p>ID</p></Container>
						</Grid.Column>
						<Grid.Column>
							<Container textAlign='left'>{employeeInfo.foto}</Container>
						</Grid.Column>
						</Grid.Row>
					<Grid.Row>
						<Grid.Column>
							<Container textAlign='right'><p>Correo</p></Container>
						</Grid.Column>
						<Grid.Column>
							<Container textAlign='left'>{employeeInfo.correo}</Container>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column>
							<Container textAlign='right'><p>Rol</p></Container>
						</Grid.Column>
						<Grid.Column>
							<Container textAlign='left'>{employeeInfo.rol}</Container>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column>
							<Container textAlign='right'><p>Nacimiento</p></Container>
						</Grid.Column>
						<Grid.Column>
							<Container textAlign='left'>{this.formatDate(employeeInfo.nacimiento)}</Container>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column>
							<Container textAlign='right'><p>Telefono</p></Container>
						</Grid.Column>
						<Grid.Column>
							<Container textAlign='left'>{employeeInfo.telefono}</Container>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Container>
		</>
		);
	}
}

export default Data;

/*
// Get the reference to the currently logged-in user
const user = firebase.auth().currentUser;

// Update user properties
user.updateProfile({
  displayName: "John Doe",
  photoURL: "https://example.com/profile.jpg"
})
  .then(() => {
    console.log("User profile updated successfully");
  })
  .catch((error) => {
    console.log("Error updating user profile:", error);
  });

// Update user email
user.updateEmail("newemail@example.com")
  .then(() => {
    console.log("User email updated successfully");
  })
  .catch((error) => {
    console.log("Error updating user email:", error);
  });

// Update user password
user.updatePassword("newPassword123")
  .then(() => {
    console.log("User password updated successfully");
  })
  .catch((error) => {
    console.log("Error updating user password:", error);
  });
*/
